module.exports = __webpack_public_path__ + "img/mail-inactive.b479bef1.svg";